export default "__VITE_ASSET__DuI6Gye4__"